import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class ParkingService {

  private url = "../assets/datacp.json";

  public getCP(): Observable<any> {
    return this.http.get(this.url);
    // const park = this.http.get(this.url);
    // return park;
  }

  constructor(private http: HttpClient) { }

}
